/*******************************************************************************
 *
 * This file is part of the LGS1920/studio project.
 *
 * File: CompassLight.jsx
 *
 * Author : LGS1920 Team
 * email: studio@lgs1920.fr
 *
 * Created on: 2026-04-29
 * Last modified: 2026-04-29
 *
 *
 * Copyright © 2026 LGS1920
 ******************************************************************************/

/**
 * CompassLight UI
 * The full compass artwork rotates based on camera heading.
 */
export const CompassLight = ({width = '100%', height = '100%', ref}) => {
    return (
        <svg
            height={height}
            width={width}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                display:         'block',
                overflow:        'visible',
                transform:       'rotate(-45deg)',
                transformBox:    'fill-box',
                transformOrigin: '50% 50%',
            }}
        >
            <g ref={ref} style={{transform: 'scale(1.2)', transformOrigin: '256px 256px'}}>
                <g className="lgs-compass-needle">
                    <path
                        className="lgs-compass-needle-north"
                        fill="var(--lgs-compass-needle-north)"
                        d="M296.327,296.354l-80.703-80.703l174.962-101.759c9.854-5.731,13.225-2.36,7.494,7.494 L296.327,296.354z"
                    />
                    <path
                        className="lgs-compass-needle-south"
                        fill="var(--lgs-compass-needle-south)"
                        d="M296.327,296.354L121.36,398.108c-9.854,5.731-13.225,2.36-7.494-7.494l101.759-174.962 L296.327,296.354z"
                    />
                </g>
                <circle
                    className="lgs-compass-needle-center"
                    fill="var(--lgs-compass-needle-center)"
                    cx="255.973"
                    cy="256"
                    r="22.8"
                />
            </g>
        </svg>
    )
}
